import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enMessages from './_metronic/i18n/messages/en.json'
import faMessages from './_metronic/i18n/messages/fa.json'
import arMessages from './_metronic/i18n/messages/ar.json'
import trMessages from './_metronic/i18n/messages/tr.json'

const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig'

const getSavedLanguage = () => {
  const config = localStorage.getItem(I18N_CONFIG_KEY)

  if (!config) {
    return 'fa'
  }

  try {
    return JSON.parse(config).selectedLang || 'fa'
  } catch {
    return 'fa'
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enMessages,
      },
      fa: {
        translation: faMessages,
      },
      ar: {
        translation: arMessages,
      },
      tr: {
        translation: trMessages,
      },
    },
    lng: getSavedLanguage(),
    fallbackLng: 'fa',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
